import styled from 'styled-components';

interface Props {
    openModal: boolean
    width?: string;
    height?: any,
    maxWidth?: string,
    maxHeight?: string,
    noScroll?: boolean,
    contentPadding?: string,
}

export const ContainerOverlay = styled.div<Props>`
  background: rgba(0, 0, 0, 0.5);
  opacity: 1;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: ${props => props.openModal ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  z-index: 9999;
  pointer-events: ${props => props.openModal ? 'auto' : 'none'};
`;

export const Container = styled.div<Props>`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    background: ${(props: any) => props.theme.colors.white};
    border-radius: 16px;
    padding: ${(props) => (props.noScroll ? (props.contentPadding || '24px') : '0')};
    width: ${props => props.width ? props.width : '400px'};
    max-width: ${props => props.maxWidth ? props.maxWidth : '90vw'};
    max-height: ${props => props.maxHeight ? props.maxHeight : '90vh'};

    @media (max-width: 800px) {
      width: 95vw !important;
      max-width: 98vw !important;
      min-width: unset !important;
      padding: ${(props) => (props.noScroll ? (props.contentPadding ? props.contentPadding : '12px') : '0')};
    }
`;

export const ScrollContent = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 24px;
    border-radius: 11px;
    scrollbar-width: thin;
    scrollbar-color: ${(props: any) => props.theme.colors.interfaceGray300} ${(props: any) => props.theme.colors.background};

    &::-webkit-scrollbar {
      width: 12px;
      background: ${(props: any) => props.theme.colors.interfaceText200};
      border-radius: 0 12px 12px 0;
    }
    &::-webkit-scrollbar-thumb {
      background: ${(props: any) => props.theme.colors.primaryBlue100};
      border-radius: 12px;
    }

    @media (max-width: 800px) {
      padding: 12px;
    }
`;
